import React, { useEffect, useRef, useCallback } from 'react';
import useState from 'react-usestateref'
import Amplify, { API, Auth } from 'aws-amplify';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { GetUserVideo, getVideo } from '../../s3Func/s3Download';
import { DragDropContainer, DropTarget } from 'react-drag-drop-container';
import { CloudfrontVideoFormat } from '../../videos/CloudfrontVideoFormat';
import tryAgainSound from '../../Unit1/Module1/assets/try_again.mp3';
import transitionSound  from '../../Unit4/Module20/glisten.mp3';
import { sleep } from '../../utils';


/**
 *  Creates and runs the practice section for Unit3 Module2
 *  Note: This code is reused in other modules as well
 * @param {*} props
 * @returns the HTML code for the practice section.
 */
const PracticeSituation = (props) => {

  const isIPad = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIPadUserAgent = /ipad/.test(userAgent) || (/macintosh/.test(userAgent) && 'ontouchend' in document);
    const isTabletScreenSize = window.innerWidth >= 768 && window.innerWidth <= 1024;
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    
    return isIPadUserAgent || (isTabletScreenSize && isTouchDevice);
  };

  const isIPhone = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIPhoneUserAgent = /iphone/.test(userAgent);
    const isSmallScreenTouch = window.innerWidth < 768 && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
    
    return isIPhoneUserAgent || isSmallScreenTouch;
  };

  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const bgs = [
    'images/newDesign/Unit4Module20/Salon/background/SalonBGLarge_new.png',
    'images/newDesign/Unit4Module20/Clothing/background/ClothingBGLarge.png',
    'images/newDesign/Unit4Module20/Bakery/background/U4M5BakeryBGClosed.png',
    'images/Module20Images/practice/GroceryChromebook.png',
    'images/newDesign/Unit4Module20/Cinema/background/CinemaBGLarge.png',
  ]

  const bgs_phone = [
    'images/Module20Images/practice/Salon_Chromebook.png',
    'images/Module20Images/practice/Clothing_Phone_4.png',
    'images/newDesign/Unit4Module20/Bakery/background/U4M5BakeryBGClosed.png',
    'images/Module20Images/practice/GroceryPhone.png',
    'images/Module20Images/practice/Cinema_Chromebook.png',
  ]
  const bgs_ipad = [
    'images/newDesign/Unit4Module20/Salon/background/SalonBGMedium_new.png',
    'images/newDesign/Unit4Module20/Clothing/background/ClothingBGMedium_new.png',
    'images/newDesign/Unit4Module20/Bakery/background/U4M5BakeryBGClosed.png',
    'images/newDesign/Unit4Module20/Grocery/background/GroceryBGMedium_new.png',
    'images/newDesign/Unit4Module20/Cinema/background/CinemaBGLarge.png',
  ]

  // Initialize variables to be used later
  const dispatch = useDispatch();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const [background, setBackground] = useState(isIPhone() ? generateImageUrl(bgs_phone[props.topicNum - 5]) : isIPad() ? generateImageUrl(bgs_ipad[props.topicNum - 5]) : generateImageUrl(bgs[props.topicNum - 5]));
  const [day7Background, setDay7Background] = useState(isIPhone() ? generateImageUrl(bgs_phone[props.topicNum - 5]) : isIPad() ? generateImageUrl(bgs_ipad[props.topicNum - 5]) : generateImageUrl(bgs[props.topicNum - 5]))
  const [question, setQuestion] = useState(false);
  const [introSound, setIntroSound] = useState('');
  const [gameInfo1, setGameInfo1] = useState ('')
  const [gameInfo2, setGameInfo2] = useState ('')
  const [gameInfo3, setGameInfo3] = useState ('')
  const [correctImgX1, setCorrectImgX1] = useState('');
  const [correctImgX2, setCorrectImgX2] = useState('');
  const [correctImgX3, setCorrectImgX3] = useState('');
  const [correctImgY1, setCorrectImgY1] = useState('');
  const [correctImgY2, setCorrectImgY2] = useState('');
  const [correctImgY3, setCorrectImgY3] = useState('');
  const [wrongImgX1, setWrongImgX1] = useState('');
  const [wrongImgX2, setWrongImgX2] = useState('');
  const [wrongImgX3, setWrongImgX3] = useState('');
  const [wrongImgY1, setWrongImgY1] = useState('');
  const [wrongImgY2, setWrongImgY2] = useState('');
  const [wrongImgY3, setWrongImgY3] = useState('');
  const [correctImg1, setCorrectImg1] = useState('');
  const [correctImg2, setCorrectImg2] = useState('');
  const [correctImg3, setCorrectImg3] = useState('');
  const [wrongImg1, setWrongImg1] = useState('');
  const [wrongImg2, setWrongImg2] = useState('');
  const [wrongImg3, setWrongImg3] = useState('');
  const [correctImg1Zoom, setCorrectImg1Zoom] = useState('');
  const [correctImg2Zoom, setCorrectImg2Zoom] = useState('');
  const [correctImg3Zoom, setCorrectImg3Zoom] = useState('');
  const [wrongImg1Zoom, setWrongImg1Zoom] = useState('');
  const [wrongImg2Zoom, setWrongImg2Zoom] = useState('');
  const [wrongImg3Zoom, setWrongImg3Zoom] = useState('');

  const [seletedImg1, setSeletedImg1] = useState('');
  const [seletedImg2, setSeletedImg2] = useState('');
  const [seletedImg3, setSeletedImg3] = useState('');
  const [seletedImgX1, setSeletedImgX1] = useState('');
  const [seletedImgX2, setSeletedImgX2] = useState('');
  const [seletedImgX3, setSeletedImgX3] = useState('');
  const [seletedImgY1, setSeletedImgY1] = useState('');
  const [seletedImgY2, setSeletedImgY2] = useState('');
  const [seletedImgY3, setSeletedImgY3] = useState('');


  const [title, setTtitle] = useState('');
  const [changeText, setChangeText] = useState('');
  const [practice1, setPractice1] = useState(false);
  const [practice2, setPractice2] = useState(false);
  const [practice3, setPractice3] = useState(false);
  const [animationEffect, setAnimationEffect] = useState('animationEffect');
  const [animationEffectAfter, setAnimationEffectAfter] = useState('animationEffect');
  const [selectedCorrectImage, setSelectedCorrectImage] = useState(0);
  const [matchOptions, setMatchOptions] = useState(null);
  const [targetKey1, setTargetKey1] = useState('');
  const [targetKey2, setTargetKey2] = useState('');
  const [targetKey3, setTargetKey3] = useState('');
  const [score, setScore] = useState(0);
  const [firstTime, setFirstTime] = useState(true);
  const [item1, setItem1] = useState(true);
  const [firstTime1, setFirstTime1] = useState(true);
  const [item2, setItem2] = useState(true);
  const [firstTime2, setFirstTime2] = useState(true);
  const [item3, setItem3] = useState(true);
  const [firstTime3, setFirstTime3] = useState(true);
  const [wrongDrag, setWrongDrag, wrongDragRef] = useState(true);

  const Exit = generateImageUrl('images/Images/close.png');
  const bounceSound = new Audio(generateImageUrl('media/Module1Videos/button_bouncing.mp3'));
  const touchSound = new Audio(generateImageUrl('media/Module1Videos/touch_button.mp3'));
  const demoDaysBirdHappy = generateImageUrl('images/Module20Images/practice/happybird.svg');
  const bigBirdHappy = generateImageUrl('images/Module20Images/practice/U4_M5_Practice_HappyBird_Big.svg');
  const demoDaysDog1GroceryBag = generateImageUrl('images/Module20Images/practice/1bag_dog.svg');
  const groceryStoreDogWithOranges = generateImageUrl('images/Module20Images/practice/U4M5_DD2_Dog-orange.svg');
  const groceryStoreDroppedBox = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_PurpleBox.svg');
  const groceryStoreCucumber = generateImageUrl('images/Module20Images/practice/U4M5_Practice_Cucumber.svg');
  const groceryStoreBird = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_BasketAndBird.svg');
  const groceryStoreSquash = generateImageUrl('images/Module20Images/practice/U4M5_Practice_Squash.svg');
  const groceryStoreBlueBoxes = generateImageUrl('images/Module20Images/practice/U4M5_Practice_BlueBoxes.svg');
  const groceryStoreGroceriesInBasket = generateImageUrl('images/Module20Images/practice/U4M5_Practice_BasketWithFood.svg');
  const groceryStoreDog2Bags = generateImageUrl('images/Module20Images/practice/twoBags_dog.svg');
  const groceryStoreBoxOnShelfStandUp = generateImageUrl('images/Module20Images/practice/U4_M5_StandupBox_With_Sparkle.svg');
  const groceryStoreBirdWithListChecked = generateImageUrl('images/Module20Images/practice/U4M5_Practice_BasketWithChecklist.svg');
  const hairSalonBirdHairMessy = generateImageUrl('images/Module20Images/practice/U4_M5_Bird_MessyHair.svg');
  const hairSalonWaterOverFlowPuddle = generateImageUrl('images/Module20Images/practice/U4_M5_SpillingSink.svg');
  const hairSalonComb = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_Comb.svg');
  const hairSalonSprayBottle = generateImageUrl('images/Module20Images/practice/U4M5_Practice_spraybottle.svg');
  const hairSalonPlant = generateImageUrl('images/Module20Images/practice/U4M5_Practice_Plant.svg');
  const hairSalonMirror = generateImageUrl('images/Module20Images/practice/U4M5_Practice_MirrorBig.svg');
  const hairSalonBird = generateImageUrl('images/Module20Images/practice/U4_M5_Bird.svg');
  const clothingStoreClothesGreenCrumpled = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_GreenClothesPile.svg');
  const clothingStoreClothesGreenFoldedOnShelf = generateImageUrl('images/Module20Images/practice/U4M5_GreenClothes_Folded.svg');
  const clothingStoreBird = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_Bird_socks.svg');
  const clothingStoreSocks = generateImageUrl('images/Module20Images/practice/U4_M5_Bird_sock_1.svg');
  const clothingStoreLizardSad = generateImageUrl('images/Module20Images/practice/U4M5_Sad_Lizard_1.svg');
  const clothingStoreLizardHappy = generateImageUrl('images/Module20Images/practice/U4M5_Happy_Lizard.svg');
  const clothingStoreMonkey = generateImageUrl('images/Module20Images/practice/U4M5_Monkey_Cashier.svg');
  const clothingStoreClothesOrange = generateImageUrl('images/Module20Images/practice/U4M5_Practice_OrangeClothes.svg');
  const clothingStoreClothesPurple = generateImageUrl('images/Module20Images/practice/U4M5_Practice_PurpleClothes.svg');
  const lizardCandy = generateImageUrl('images/Module20Images/practice/U4M5_Happy_Lizard_candy.svg');

  const bakeryCrabBoxesWorried = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_Crab_Box.svg');
  const bakeryBird = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_Bird_Messyface.svg');
  const bakeryTrashCanCupcake = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_TrashCan_Big.svg');
  const bakeryLightSwitch = generateImageUrl('images/Module20Images/practice/U4M5_Practice_Lightswitch.svg');
  const bakeryBreadRoll = generateImageUrl('images/newDesign/Unit4Module20/Bakery/assets/Unit4Module20BreadSmall.png');
  const bakeryBreadLoaf = generateImageUrl('images/Module20Images/practice/U4M5_Practice_BreadLoaf.svg');
  const bakeryNapkinWithBird = generateImageUrl('images/Module20Images/practice/U4_M5_Bird_napkin.svg');
  const bakeryTrashCanMess = generateImageUrl('images/Module20Images/practice/trash_can_mess.svg');
  const bakeryCrabSmiling = generateImageUrl('images/Module20Images/practice/U4M5_Practice_Crab_Boxes_happy.svg');
  const bakerySparkle = generateImageUrl('images/Module20Images/practice/U4M5_Practice_TrashCan_clean.svg');
  const movieLightSwitch = generateImageUrl('images/Module20Images/practice/U4M5_Practice_Lightswitch.svg');
  const movieBird = generateImageUrl('images/Module20Images/practice/Bird_Lost .svg');
  const movieMonkeyHungry = generateImageUrl('images/Module20Images/practice/U4M5_Monkey_Hungry.svg');
  const moviePoster = generateImageUrl('images/newDesign/Unit4Module20/Cinema/assets/Unit4Module20Poster.png');
  const movieCrab = generateImageUrl('images/Module20Images/practice/U4M5_StaffCrab.svg');
  const movieRecycleBinWithBottle = generateImageUrl('images/Module20Images/practice/U4M5_Practice_INVOutline_RecycleandBottles_1.svg');
  const movieCrabPointing = generateImageUrl('images/Module20Images/practice/U4M5_Practice_CrabPointing.svg');
  const movie2WaterBottles = generateImageUrl('images/Module20Images/practice/U4M5_Practic_Recycleand2Bottle_1.svg');
  const movieMonkey = generateImageUrl('images/Module20Images/practice/U4M5_Monkey_Normal.svg');
  const movieMonkeyHappy = generateImageUrl('images/Module20Images/practice/U4M5_Monkey_Happy_popcorn.svg');
  const movieCrabThoughtHeart = generateImageUrl('images/Module20Images/practice/U4M5_StaffCrab_heart.svg');
  const movieRecycleBinSparkle = generateImageUrl('images/Module20Images/practice/U4_M5_RecycleBin_Clean_1.svg');
  const combHair = {
      img: generateImageUrl('images/Module20Images/practiceIcon/comb hair.png'),
      title: 'Comb your hair',
      audioPrompt: 'appfiles/caring/option_comb_your_hair.mp3',
  };
  const recycle = {
      img: generateImageUrl('images/Module20Images/practiceIcon/receycle bottle.png'),
      title: 'Recycle the bottle',
      audioPrompt: 'appfiles/caring/option_recycle_the_bottle.mp3',
  };
  const mop = {
      img: generateImageUrl('images/Module20Images/practiceIcon/mop.png'),
      title: 'Mop',
      audioPrompt: 'appfiles/caring/option_mop.mp3',
  };
  const smile = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Smile.png'),
      title: 'Smile',
      audioPrompt: 'appfiles/caring/option_smile.mp3',
  };
  const getGroceries = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Get groceries.png'),
      title: 'Get groceries',
      audioPrompt: 'appfiles/caring/option_get_groceries.mp3',
  };
  const newBag = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Get a new bag 2x.png'),
      title: 'Get a new bag',
      audioPrompt: 'appfiles/caring/option_get_a_new_bag.mp3',
  };
  const carry = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Help carry the bag copy.png'),
      title: 'Help carry the bag',
      audioPrompt: 'appfiles/caring/option_help_carry_the_bag.mp3',
  };
  let pickUpBox = {
      img: generateImageUrl('images/Module20Images/practiceIcon/pick up the box.png'),
      title: "Pick up box",
      audioPrompt: 'appfiles/caring/option_pick_up_the_box.mp3'
  }
  let standUpTheBox = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Stand up the box.png'),
      title: "Stand up the box",
      audioPrompt: 'appfiles/caring/option_stand_up_the_box.mp3'
  }
  let doubleCheck = {
      img: generateImageUrl('images/Module20Images/practiceIcon/check list.png'),
      title: "Double check the grocery list",
      audioPrompt: 'appfiles/caring/option_double_check_the_grocery_list.mp3'
  }
  let askForHaircut = {
      img: generateImageUrl('images/Module20Images/practiceIcon/ask for a haircut.png'),
      title: "Ask for haircut",
      audioPrompt: 'appfiles/caring/option_ask_for_a_haircut.mp3'
  }
  let pickUpComb = {
      img: generateImageUrl('images/Module20Images/practiceIcon/pick up the comb.png'),
      title: "Pick up the comb",
      audioPrompt: 'appfiles/caring/option_pick_up_the_comb.mp3'
  }
  let stopWater = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Stop the water.png'),
      title: "Stop the water",
      audioPrompt: 'appfiles/caring/option_stop_the_water.mp3'
  }
  let thankYou = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Say thank you.png'),
      title: `Say, "Thank you!"`,
      audioPrompt: 'appfiles/caring/option_say_thank_you.mp3'
  }
  let giveCombToStylist = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Give comb to hairstylist.png'),
      title: "Give the comb to stylist",
      audioPrompt: 'appfiles/caring/option_give_the_comb_to_the_hairstylist.mp3'
  }
  let mopTheFloo = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Mop the floor.png'),
      title: "Mop the floor",
      audioPrompt: 'appfiles/caring/option_mop_the_floor.mp3'
  }
  let pickUpClothes = {
      img: generateImageUrl('images/Module20Images/practiceIcon/pick up the clothes.png'),
      title: "Pick up the clothes",
      audioPrompt: 'appfiles/caring/option_pick_up_the_clothes.mp3'
  }
  let askForSocks = {
      img: generateImageUrl('images/Module20Images/practiceIcon/Ask for socks.png'),
      title: "Ask for socks",
      audioPrompt: 'appfiles/caring/option_ask_for_socks.mp3'
  }
  let cheerUp = {
      img: generateImageUrl('images/Module20Images/practiceIcon/cheer them up.png'),
      title: "Cheer them up",
      audioPrompt: 'appfiles/caring/option_cheer_them_up.mp3'
  }
  let buySocks = {
      img: generateImageUrl('images/Module20Images/practiceIcon/buy the socks.png'),
      title: "Buy the socks",
      audioPrompt: 'appfiles/caring/option_buy_the_socks.mp3'
  }
  let foldClothes = {
      img: generateImageUrl('images/Module20Images/practiceIcon/fold the clothes.png'),
      title: "Fold the clothes",
      audioPrompt: 'appfiles/caring/option_fold_the_clothes.mp3'
  }
  let shareCandy = {
      img: generateImageUrl('images/Module20Images/practiceIcon/share candy.png'),
      title: "Share the candy",
      audioPrompt: 'appfiles/caring/option_share_candy.mp3'
  }
  let openDoor = {
      img: generateImageUrl('images/Module20Images/practiceIcon/open the  door.png'),
      title: "Open the door",
      audioPrompt: 'appfiles/caring/option_open_the_door.mp3'
  }
  let throwAwayCupcake = {
      img: generateImageUrl('images/Module20Images/practiceIcon/throw away cupcake.png'),
      title: "Throw away the cupcake",
      audioPrompt: 'appfiles/caring/option_throw_away.mp3'
  }
  let wipeFace = {
      img: generateImageUrl('images/Module20Images/practiceIcon/whipe your face.png'),
      title: "Wipe the face",
      audioPrompt: 'appfiles/caring/option_wipe_your_face.mp3'
  }
  let smileAtCrab = {
      img: generateImageUrl('images/Module20Images/practiceIcon/smile at the crab.png'),
      title: "Smile at the crab",
      audioPrompt: 'appfiles/caring/option_smile_at_the_crab.mp3'
  }
  let throwAwayNapkin = {
      img: generateImageUrl('images/Module20Images/practiceIcon/throw away napkin.png'),
      title: "Throw away the napkin",
      audioPrompt: 'appfiles/caring/option_throw_away.mp3'
  }
  let cleanMess = {
      img: generateImageUrl('images/Module20Images/practiceIcon/clean up the mess.png'),
      title: "Clean up the mess",
      audioPrompt: 'appfiles/caring/option_clean_up_the_mess.mp3'
  }
  let askForHelp = {
      img: generateImageUrl('images/Module20Images/practiceIcon/ask for help.png'),
      title: "Ask for help",
      audioPrompt: 'appfiles/caring/option_ask_for_help.mp3'
  }
  let sharePopcorn = {
      img: generateImageUrl('images/Module20Images/practiceIcon/share popcorn.png'),
      title: "Share the popcorn",
      audioPrompt: 'appfiles/caring/option_share_popcorn.mp3'
  }
  let recycleTheOtherBottles = {
      img: generateImageUrl('images/Module20Images/practiceIcon/recycle the other bottle.png'),
      title: "Recycle the other bottles",
      audioPrompt: 'appfiles/caring/option_recycle_the_other_bottles.mp3'
  }
  let shareMorePopcorn = {
      img: generateImageUrl('images/Module20Images/practiceIcon/share more popcorn.png'),
      title: "Share more popcorn",
      audioPrompt: 'appfiles/caring/option_share_more_popcorn.mp3'
  }

  useEffect(() => {
    let gameInfo1 = {}
    switch (props.topicNum) {
      case 8:
        if (isIPhone()) {
          gameInfo1 = {
            correctOptions: [groceryStoreDogWithOranges, groceryStoreDroppedBox, groceryStoreBird],
            incorrectOptions: [groceryStoreCucumber, groceryStoreSquash, groceryStoreBlueBoxes],
            position: [
              { x: '50%', y: '75%', zoom:'80%' },
              { x: '5%', y: '80%', zoom:'70%' },
              { x: '30%', y: '60%', zoom:'60%' },
              { x: '75%', y: '63%', zoom:'80%' },
              { x: '69%', y: '45%', zoom:'100%' },
              { x: '-15%', y: '60%', zoom:'80%' },
            ],
          }
          setGameInfo1({
            correctOptions: [groceryStoreDogWithOranges, groceryStoreDroppedBox, groceryStoreBird],
            incorrectOptions: [groceryStoreCucumber, groceryStoreSquash, groceryStoreBlueBoxes],
            position: [
              { x: '50%', y: '75%', zoom:'80%' },
              { x: '5%', y: '80%', zoom:'70%' },
              { x: '30%', y: '60%', zoom:'60%' },
              { x: '75%', y: '63%', zoom:'80%' },
              { x: '69%', y: '45%', zoom:'100%' },
              { x: '-15%', y: '60%', zoom:'80%' },
            ],
          })
          setGameInfo2({
            options: [newBag, pickUpBox, getGroceries],
            position: [
              { x: '68%', y: '75%' },
              { x: '2%', y: '75%' },
              { x: '38%', y: '70%' },
            ],
            answer1ImagesEnd: [groceryStoreDog2Bags],
            answer2ImagesEnd: [groceryStoreDroppedBox],
            answer3ImagesEnd: [groceryStoreGroceriesInBasket],
            afterPosition: [
              { x: '50%', y: '75%' },
              { x: '1%', y: '25%' },
              { x: '30%', y: '60%' },
            ],
          })
          setGameInfo3({
            options: [carry, standUpTheBox, doubleCheck],
            position: [
              { x: '68%', y: '75%' },
              { x: '0%', y: '20%' },
              { x: '38%', y: '70%' },
            ],
            answer1ImagesEnd: [demoDaysDog1GroceryBag],
            answer2ImagesEnd: [groceryStoreBoxOnShelfStandUp],
            answer3ImagesEnd: [groceryStoreBirdWithListChecked],
            answer4ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4M5_Heart_Thought.svg')],
            afterPosition: [
              { x: '50%', y: '75%' },
              { x: '2%', y: '16%' },
              { x: '30%', y: '60%' },
            ],
          })
        }
        else if (isIPad()) {
          gameInfo1 = {
            correctOptions: [groceryStoreDogWithOranges, groceryStoreDroppedBox, groceryStoreBird],
            incorrectOptions: [groceryStoreCucumber, groceryStoreSquash, groceryStoreBlueBoxes],
            position: [
              { x: '55%', y: '70%', zoom:'90%' },
              { x: '15%', y: '75%', zoom:'80%' },
              { x: '35%', y: '50%', zoom:'75%' },
              { x: '90%', y: '36%', zoom:'90%' },
              { x: '65%', y: '30%', zoom:'110%' },
              { x: '0%', y: '45%', zoom:'90%' },
            ],
          }
          setGameInfo1({
            correctOptions: [groceryStoreDogWithOranges, groceryStoreDroppedBox, groceryStoreBird],
            incorrectOptions: [groceryStoreCucumber, groceryStoreSquash, groceryStoreBlueBoxes],
            position: [
              { x: '55%', y: '70%', zoom:'90%' },
              { x: '15%', y: '75%', zoom:'80%' },
              { x: '35%', y: '50%', zoom:'75%' },
              { x: '90%', y: '36%', zoom:'90%' },
              { x: '65%', y: '30%', zoom:'110%' },
              { x: '0%', y: '45%', zoom:'90%' },
            ],
          })
          setGameInfo2({
            options: [newBag, pickUpBox, getGroceries],
            position: [
              { x: '65%', y: '70%' },
              { x: '15%', y: '70%' },
              { x: '42%', y: '65%' },
            ],
            answer1ImagesEnd: [groceryStoreDog2Bags],
            answer2ImagesEnd: [groceryStoreDroppedBox],
            answer3ImagesEnd: [groceryStoreGroceriesInBasket],
            afterPosition: [
              { x: '55%', y: '70%' },
              { x: '8%', y: '35%' },
              { x: '35%', y: '50%' },
            ],
          })
          setGameInfo3({
            options: [carry, standUpTheBox, doubleCheck],
            position: [
              { x: '65%', y: '70%' },
              { x: '8%', y: '35%' },
              { x: '42%', y: '65%' },
            ],
            answer1ImagesEnd: [demoDaysDog1GroceryBag],
            answer2ImagesEnd: [groceryStoreBoxOnShelfStandUp],
            answer3ImagesEnd: [groceryStoreBirdWithListChecked],
            answer4ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4M5_Heart_Thought.svg')],
            afterPosition: [
              { x: '55%', y: '70%' },
              { x: '8%', y: '25%' },
              { x: '35%', y: '50%' },
            ],
          })
        }
        else {
          gameInfo1 = {
            correctOptions: [groceryStoreDogWithOranges, groceryStoreDroppedBox, groceryStoreBird],
            incorrectOptions: [groceryStoreCucumber, groceryStoreSquash, groceryStoreBlueBoxes],
            position: [
              { x: '62%', y: '65%', zoom:'100%' },
              { x: '25%', y: '80%', zoom:'100%' },
              { x: '40%', y: '35%', zoom:'100%' },
              { x: '90%', y: '59%', zoom:'100%' },
              { x: '69%', y: '49%', zoom:'100%' },
              { x: '0.5%', y: '65%', zoom:'100%' },
            ],
          }
          setGameInfo1({
            correctOptions: [groceryStoreDogWithOranges, groceryStoreDroppedBox, groceryStoreBird],
            incorrectOptions: [groceryStoreCucumber, groceryStoreSquash, groceryStoreBlueBoxes],
            position: [
              { x: '62%', y: '65%', zoom:'100%' },
              { x: '25%', y: '80%', zoom:'100%' },
              { x: '40%', y: '35%', zoom:'100%' },
              { x: '90%', y: '59%', zoom:'100%' },
              { x: '69%', y: '49%', zoom:'100%' },
              { x: '0.5%', y: '65%', zoom:'100%' },
            ],
          })
          setGameInfo2({
            options: [newBag, pickUpBox, getGroceries],
            position: [
              { x: '70%', y: '72%' },
              { x: '25%', y: '75%' },
              { x: '48%', y: '70%' },
            ],
            answer1ImagesEnd: [groceryStoreDog2Bags],
            answer2ImagesEnd: [groceryStoreDroppedBox],
            answer3ImagesEnd: [groceryStoreGroceriesInBasket],
            afterPosition: [
              { x: '62%', y: '65%' },
              { x: '9%', y: '50%' },
              { x: '40%', y: '35%' },
            ],
          })
          setGameInfo3({
            options: [carry, standUpTheBox, doubleCheck],
            position: [
              { x: '70%', y: '72%' },
              { x: '9%', y: '46%' },
              { x: '48%', y: '70%' },
            ],
            answer1ImagesEnd: [demoDaysDog1GroceryBag],
            answer2ImagesEnd: [groceryStoreBoxOnShelfStandUp],
            answer3ImagesEnd: [groceryStoreBirdWithListChecked],
            answer4ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4M5_Heart_Thought.svg')],
            afterPosition: [
              { x: '62%', y: '65%' },
              { x: '10%', y: '40%' },
              { x: '40%', y: '35%' },
            ],
          })
        }
        break;
      case 5:
          if (isIPhone()) {
            gameInfo1 = {
              correctOptions: [hairSalonBirdHairMessy, hairSalonComb, hairSalonWaterOverFlowPuddle],
              incorrectOptions: [hairSalonSprayBottle, hairSalonPlant, hairSalonPlant],
              position: [
                { x: '5%', y: '75%', zoom:'80%' },
                { x: '35%', y: '90%', zoom:'40%' },
                { x: '0%', y: '5%', zoom:'90%' },
                { x: '-5%', y: '53%', zoom:'100%' },
                { x: '65%', y: '40%', zoom:'100%' },
                { x: '6%', y: '45%', zoom:'120%' },
              ],
            }
            setGameInfo1({
              correctOptions: [hairSalonBirdHairMessy, hairSalonComb, hairSalonWaterOverFlowPuddle],
              incorrectOptions: [hairSalonSprayBottle, hairSalonPlant, hairSalonPlant],
              position: [
                { x: '5%', y: '75%', zoom:'80%' },
                { x: '35%', y: '90%', zoom:'40%' },
                { x: '0%', y: '5%', zoom:'90%' },
                { x: '-5%', y: '53%', zoom:'100%' },
                { x: '65%', y: '40%', zoom:'100%' },
                { x: '6%', y: '45%', zoom:'120%' },
              ],
            })
            setGameInfo2({
              options: [askForHaircut, pickUpComb, stopWater],
              position: [
                { x: '0%', y: '75%' },
                { x: '30%', y: '85%' },
                { x: '20%', y: '30%' },
              ],
              answer1ImagesEnd: [hairSalonBird],
              answer2ImagesEnd: [hairSalonComb],
              answer3ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4_M5_Puddle.svg')],
              afterPosition: [
                { x: '5%', y: '77%' },
                { x: '15%', y: '85%' },
                { x: '30%', y: '150%' },
              ],
            })
            setGameInfo3({
              options: [thankYou, giveCombToStylist, mopTheFloo],
              position: [
                { x: '7%', y: '70%' },
                { x: '60%', y: '80%' },
                { x: '30%', y: '130%' },
              ],
              answer1ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4M5_Heart_Thought.svg')],
              answer2ImagesEnd: [generateImageUrl('images/Module20Images/practice/Hairstylist_Happy.svg')],
              answer3ImagesEnd: [null],
              answer4ImagesEnd: [demoDaysBirdHappy],
              afterPosition: [
                { x: '15%', y: '62%' },
                { x: '55%', y: '77%', zoom:'95%' },
                { x: '30%', y: '45%' },
              ],
            })
          }
          else if (isIPad()) {
            gameInfo1 = {
              correctOptions: [hairSalonBirdHairMessy, hairSalonComb, hairSalonWaterOverFlowPuddle],
              incorrectOptions: [hairSalonSprayBottle, hairSalonPlant, hairSalonPlant],
              position: [
                { x: '10%', y: '65%', zoom:'90%' },
                { x: '37%', y: '85%', zoom:'50%' },
                { x: '5%', y: '10%', zoom:'85%' },
                { x: '10%', y: '0%', zoom:'115%' },
                { x: '0%', y: '0%', zoom:'130%' },
                { x: '20%', y: '0%', zoom:'145%' },
              ],
            }
            setGameInfo1({
              correctOptions: [hairSalonBirdHairMessy, hairSalonComb, hairSalonWaterOverFlowPuddle],
              incorrectOptions: [hairSalonSprayBottle, hairSalonPlant, hairSalonPlant],
              position: [
                { x: '10%', y: '65%', zoom:'90%' },
                { x: '37%', y: '85%', zoom:'50%' },
                { x: '5%', y: '10%', zoom:'85%' },
                { x: '10%', y: '0%', zoom:'115%' },
                { x: '0%', y: '0%', zoom:'130%' },
                { x: '20%', y: '0%', zoom:'145%' },
              ],
            })
            setGameInfo2({
              options: [askForHaircut, pickUpComb, stopWater],
              position: [
                { x: '10%', y: '68%' },
                { x: '35%', y: '80%' },
                { x: '25%', y: '25%' },
              ],
              answer1ImagesEnd: [hairSalonBird],
              answer2ImagesEnd: [hairSalonComb],
              answer3ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4_M5_Puddle.svg')],
              afterPosition: [
                { x: '10%', y: '65%' },
                { x: '20%', y: '75%' },
                { x: '35%', y: '150%' },
              ],
            })
            setGameInfo3({
              options: [thankYou, giveCombToStylist, mopTheFloo],
              position: [
                { x: '10%', y: '65%' },
                { x: '58%', y: '75%' },
                { x: '35%', y: '130%' },
              ],
              answer1ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4M5_Heart_Thought.svg')],
              answer2ImagesEnd: [generateImageUrl('images/Module20Images/practice/Hairstylist_Happy.svg')],
              answer3ImagesEnd: [null],
              answer4ImagesEnd: [demoDaysBirdHappy],
              afterPosition: [
                { x: '70%', y: '65%' },
                { x: '56%', y: '75%', zoom:'115%' },
                { x: '35%', y: '40%' },
              ],
            })
          }
          else {
            gameInfo1 = {
              correctOptions: [hairSalonBirdHairMessy, hairSalonComb, hairSalonWaterOverFlowPuddle],
              incorrectOptions: [hairSalonSprayBottle, hairSalonPlant, hairSalonPlant],
              position: [
                { x: '15%', y: '58%', zoom:'100%' },
                { x: '40%', y: '80%', zoom:'50%' },
                { x: '0%', y: '5%', zoom:'90%' },
                { x: '20%', y: '0%', zoom:'100%' },
                { x: '10%', y: '0%', zoom:'100%' },
                { x: '30%', y: '0%', zoom:'90%' },
              ],
            }
            setGameInfo1({
              correctOptions: [hairSalonBirdHairMessy, hairSalonComb, hairSalonWaterOverFlowPuddle],
              incorrectOptions: [hairSalonSprayBottle, hairSalonPlant, hairSalonPlant],
              position: [
                { x: '15%', y: '58%', zoom:'100%' },
                { x: '40%', y: '80%', zoom:'50%' },
                { x: '0%', y: '5%', zoom:'90%' },
                { x: '20%', y: '0%', zoom:'100%' },
                { x: '10%', y: '0%', zoom:'100%' },
                { x: '30%', y: '0%', zoom:'90%' },
              ],
            })
            setGameInfo2({
              options: [askForHaircut, pickUpComb, stopWater],
              position: [
                { x: '15%', y: '60%' },
                { x: '37%', y: '75%' },
                { x: '20%', y: '30%' },
              ],
              answer1ImagesEnd: [hairSalonBird],
              answer2ImagesEnd: [hairSalonComb],
              answer3ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4_M5_Puddle.svg')],
              afterPosition: [
                { x: '15%', y: '58%' },
                { x: '15%', y: '70%' },
                { x: '30%', y: '160%' },
              ],
            })
            setGameInfo3({
              options: [thankYou, giveCombToStylist, mopTheFloo],
              position: [
                { x: '15%', y: '60%' },
                { x: '60%', y: '70%' },
                { x: '30%', y: '140%' },
              ],
              answer1ImagesEnd: [generateImageUrl('images/Module20Images/practice/U4M5_Heart_Thought.svg')],
              answer2ImagesEnd: [generateImageUrl('images/Module20Images/practice/Hairstylist_Happy.svg')],
              answer3ImagesEnd: [null],
              answer4ImagesEnd: [demoDaysBirdHappy],
              afterPosition: [
                { x: '65%', y: '50%' },
                { x: '58%', y: '60%', zoom:'120%' },
                { x: '30%', y: '45%' },
              ],
            })
          }
          break;
      case 6:
        if (isIPhone()) {
          gameInfo1 = {
            correctOptions: [clothingStoreBird, clothingStoreLizardSad, clothingStoreClothesGreenCrumpled],
            incorrectOptions: [clothingStoreClothesOrange, clothingStoreClothesPurple, clothingStoreMonkey],
            position: [
              { x: '65%', y: '78%', zoom:'60%' },
              { x: '2%', y: '85%', zoom:'60%' },
              { x: '100%', y: '80%', zoom:'100%' },
              { x: '50%', y: '40%', zoom:'90%'},
              { x: '7%', y: '72%', zoom:'90%'},
              { x: '65%', y: '60%', zoom:'70%'},
            ],
          }
          setGameInfo1({
            correctOptions: [clothingStoreBird, clothingStoreLizardSad, clothingStoreClothesGreenCrumpled],
            incorrectOptions: [clothingStoreClothesOrange, clothingStoreClothesPurple, clothingStoreMonkey],
            position: [
              { x: '65%', y: '78%', zoom:'60%' },
              { x: '2%', y: '85%', zoom:'60%' },
              { x: '100%', y: '80%', zoom:'100%' },
              { x: '50%', y: '40%', zoom:'90%'},
              { x: '7%', y: '72%', zoom:'90%'},
              { x: '65%', y: '60%', zoom:'70%'},
            ],
          })
          setGameInfo2({
            options: [askForSocks, cheerUp, pickUpClothes],
            position: [
              { x: '65%', y: '60%' },
              { x: '13%', y: '85%' },
              { x: '105%', y: '70%' },
            ],
            answer3ImagesEnd: [clothingStoreClothesGreenCrumpled],
            answer1ImagesEnd: [clothingStoreSocks],
            answer2ImagesEnd: [clothingStoreLizardHappy],
            afterPosition: [
              { x: '65%', y: '78%' },
              { x: '2%', y: '85%' },
              { x: '50%', y: '15%' },

            ],
          })
          setGameInfo3({
            options: [buySocks, shareCandy, foldClothes],
            position: [
              { x: '65%', y: '60%' },
              { x: '13%', y: '85%' },
              { x: '50%', y: '5%' },
            ],
            answer3ImagesEnd: [clothingStoreClothesGreenFoldedOnShelf],
            answer1ImagesEnd: [bigBirdHappy],
            answer2ImagesEnd: [lizardCandy],
            afterPosition: [
              { x: '65%', y: '78%', zoom:'100%' },
              { x: '2%', y: '85%', zoom:'60%' },
              { x: '50%', y: '10%', zoom:'100%' },
            ],
          })
        }
        else if (isIPad()) {
          gameInfo1 = {
            correctOptions: [clothingStoreBird, clothingStoreLizardSad, clothingStoreClothesGreenCrumpled],
            incorrectOptions: [clothingStoreClothesOrange, clothingStoreClothesPurple, clothingStoreMonkey],
            position: [
              { x: '70%', y: '70%', zoom:'80%' },
              { x: '8%', y: '70%', zoom:'100%' },
              { x: '100%', y: '75%', zoom:'100%' },
              { x: '53%', y: '42%', zoom:'90%'},
              { x: '11%', y: '73%', zoom:'90%'},
              { x: '60%', y: '45%', zoom:'90%'},
            ],
          }
          setGameInfo1({
            correctOptions: [clothingStoreBird, clothingStoreLizardSad, clothingStoreClothesGreenCrumpled],
            incorrectOptions: [clothingStoreClothesOrange, clothingStoreClothesPurple, clothingStoreMonkey],
            position: [
              { x: '70%', y: '70%', zoom:'80%' },
              { x: '8%', y: '70%', zoom:'100%' },
              { x: '100%', y: '75%', zoom:'100%' },
              { x: '53%', y: '42%', zoom:'90%'},
              { x: '11%', y: '73%', zoom:'90%'},
              { x: '60%', y: '45%', zoom:'90%'},
            ],
          })
          setGameInfo2({
            options: [askForSocks, cheerUp, pickUpClothes],
            position: [
              { x: '65%', y: '55%' },
              { x: '18%', y: '75%' },
              { x: '100%', y: '65%' },
            ],
            answer3ImagesEnd: [clothingStoreClothesGreenCrumpled],
            answer1ImagesEnd: [clothingStoreSocks],
            answer2ImagesEnd: [clothingStoreLizardHappy],
            afterPosition: [
              { x: '70%', y: '70%' },
              { x: '8%', y: '70%' },
              { x: '50%', y: '12%' },
            ],
          })
          setGameInfo3({
            options: [buySocks, shareCandy, foldClothes],
            position: [
              { x: '75%', y: '55%' },
              { x: '18%', y: '75%' },
              { x: '55%', y: '10%' },
            ],
            answer3ImagesEnd: [clothingStoreClothesGreenFoldedOnShelf],
            answer1ImagesEnd: [bigBirdHappy],
            answer2ImagesEnd: [lizardCandy],
            afterPosition: [
              { x: '70%', y: '70%' },
              { x: '8%', y: '70%' },
              { x: '51%', y: '10%' },
            ],
          })
        }
        else {
          if (window.innerHeight > 1000) {
            gameInfo1 = {
              correctOptions: [clothingStoreBird, clothingStoreLizardSad, clothingStoreClothesGreenCrumpled],
              incorrectOptions: [clothingStoreClothesOrange, clothingStoreClothesPurple, clothingStoreMonkey],
              position: [
                { x: '75%', y: '50%', zoom:'100%' },
                { x: '2%', y: '70%', zoom:'100%' },
                { x: '100%', y: '80%', zoom:'100%' },
                { x: '50%', y: '40%', zoom:'120%'},
                { x: '7%', y: '72%', zoom:'120%'},
                { x: '53%', y: '30%', zoom:'100%' },
              ],
            }
            setGameInfo1({
              correctOptions: [clothingStoreBird, clothingStoreLizardSad, clothingStoreClothesGreenCrumpled],
              incorrectOptions: [clothingStoreClothesOrange, clothingStoreClothesPurple, clothingStoreMonkey],
              position: [
                { x: '75%', y: '50%', zoom:'100%' },
                { x: '2%', y: '70%', zoom:'100%' },
                { x: '100%', y: '80%', zoom:'100%' },
                { x: '50%', y: '40%', zoom:'120%'},
                { x: '7%', y: '72%', zoom:'120%'},
                { x: '53%', y: '30%', zoom:'100%' },
              ],
            })
            setGameInfo2({
              options: [askForSocks, cheerUp, pickUpClothes],
              position: [
                { x: '55%', y: '29%' },
                { x: '13%', y: '80%' },
                { x: '105%', y: '70%' },
              ],
              answer3ImagesEnd: [clothingStoreClothesGreenCrumpled],
              answer1ImagesEnd: [clothingStoreSocks],
              answer2ImagesEnd: [clothingStoreLizardHappy],
              afterPosition: [
                { x: '75%', y: '50%' },
                { x: '2%', y: '70%' },
                { x: '50%', y: '15%' },

              ],
            })
            setGameInfo3({
              options: [buySocks, shareCandy, foldClothes],
              position: [
                { x: '55%', y: '29%' },
                { x: '13%', y: '80%' },
                { x: '55%', y: '10%' },
              ],
              answer3ImagesEnd: [clothingStoreClothesGreenFoldedOnShelf],
              answer1ImagesEnd: [bigBirdHappy],
              answer2ImagesEnd: [lizardCandy],
              afterPosition: [
                { x: '75%', y: '50%' },
                { x: '2%', y: '70%' },
                { x: '50%', y: '10%' },
              ],
                        })
          }
          else {
            gameInfo1 = {
              correctOptions: [clothingStoreBird, clothingStoreLizardSad, clothingStoreClothesGreenCrumpled],
              incorrectOptions: [clothingStoreClothesOrange, clothingStoreClothesPurple, clothingStoreMonkey],
              position: [
                { x: '75%', y: '50%', zoom:'100%' },
                { x: '2%', y: '70%', zoom:'100%' },
                { x: '100%', y: '80%', zoom:'100%' },
                { x: '50%', y: '40%', zoom:'90%'},
                { x: '7%', y: '72%', zoom:'90%'},
                { x: '53%', y: '30%', zoom:'100%'},
              ],
            }
            setGameInfo1({
              correctOptions: [clothingStoreBird, clothingStoreLizardSad, clothingStoreClothesGreenCrumpled],
              incorrectOptions: [clothingStoreClothesOrange, clothingStoreClothesPurple, clothingStoreMonkey],
              position: [
                { x: '75%', y: '50%', zoom:'100%' },
                { x: '2%', y: '70%', zoom:'100%' },
                { x: '100%', y: '80%', zoom:'100%' },
                { x: '50%', y: '40%', zoom:'90%'},
                { x: '7%', y: '72%', zoom:'90%'},
                { x: '53%', y: '30%', zoom:'100%'},
              ],
            })
            setGameInfo2({
              options: [askForSocks, cheerUp, pickUpClothes],
              position: [
                { x: '55%', y: '29%' },
                { x: '13%', y: '80%' },
                { x: '105%', y: '70%' },
              ],
              answer3ImagesEnd: [clothingStoreClothesGreenCrumpled],
              answer1ImagesEnd: [clothingStoreSocks],
              answer2ImagesEnd: [clothingStoreLizardHappy],
              afterPosition: [
                { x: '75%', y: '50%' },
                { x: '2%', y: '70%' },
                { x: '50%', y: '15%' },

              ],
            })
            setGameInfo3({
              options: [buySocks, shareCandy, foldClothes],
              position: [
                { x: '55%', y: '29%' },
                { x: '13%', y: '80%' },
                { x: '55%', y: '10%' },
              ],
              answer3ImagesEnd: [clothingStoreClothesGreenFoldedOnShelf],
              answer1ImagesEnd: [bigBirdHappy],
              answer2ImagesEnd: [lizardCandy],
              afterPosition: [
                { x: '75%', y: '50%' },
                { x: '2%', y: '70%' },
                { x: '50%', y: '10%' },
              ],
            })
          }
        }
        break;
      case 7:
        if (isIPhone()) {
          gameInfo1 = {
            correctOptions: [bakeryCrabBoxesWorried, bakeryBird, bakeryTrashCanCupcake],
            incorrectOptions: [bakeryLightSwitch, bakeryBreadRoll, bakeryBreadLoaf],
            position: [
              { x: '0%', y: '70%', zoom: "55%"},
              { x: '40%', y: '60%', zoom: "55%"},
              { x: '70%', y: '70%', zoom: "55%"},
              { x: '23%', y: '40%', zoom: "80%"},
              { x: '30%', y: '56%', zoom: "100%"},
              { x: '65%', y: '50%', zoom: '80%' },
            ],
          }
          setGameInfo1({
            correctOptions: [bakeryCrabBoxesWorried, bakeryBird, bakeryTrashCanCupcake],
            incorrectOptions: [bakeryLightSwitch, bakeryBreadRoll, bakeryBreadLoaf],
            position: [
              { x: '0%', y: '70%', zoom: "55%"},
              { x: '40%', y: '60%', zoom: "55%"},
              { x: '70%', y: '70%', zoom: "55%"},
              { x: '23%', y: '40%', zoom: "80%"},
              { x: '30%', y: '56%', zoom: "100%"},
              { x: '65%', y: '50%', zoom: '80%' },
            ],
          })
          setGameInfo2({
            options: [openDoor, wipeFace, throwAwayCupcake],
            position: [
              { x: '5%', y: '70%' },
              { x: '40%', y: '60%' },
              { x: '75%', y: '70%' },
            ],
            answer1ImagesEnd: [bakeryCrabBoxesWorried],
            answer2ImagesEnd: [bakeryNapkinWithBird],
            answer3ImagesEnd: [bakeryTrashCanMess],
            afterPosition: [
              { x: '0%', y: '70%' },
              { x: '40%', y: '60%' },
              { x: '70%', y: '70%' },
            ],
          })
          setGameInfo3({
            options: [smileAtCrab, throwAwayNapkin, cleanMess],
            position: [
              { x: '5%', y: '70%' },
              { x: '40%', y: '60%' },
              { x: '75%', y: '70%' },
            ],
            answer1ImagesEnd: [bakeryCrabSmiling],
            answer2ImagesEnd: [bigBirdHappy],
            answer3ImagesEnd: [bakerySparkle],
            afterPosition: [
              { x: '0%', y: '70%' },
              { x: '40%', y: '60%', zoom: "60%"},
              { x: '70%', y: '70%' },
            ],
          })
        }
        else if (isIPad()) {
          gameInfo1 = {
            correctOptions: [bakeryCrabBoxesWorried, bakeryBird, bakeryTrashCanCupcake],
            incorrectOptions: [bakeryLightSwitch, bakeryBreadRoll, bakeryBreadLoaf],
            position: [
              { x: '0%', y: '60%'},
              { x: '42%', y: '50%'},
              { x: '70%', y: '60%'},
              { x: '33%', y: '28%'},
              { x: '28%', y: '54%'},
              { x: '65%', y: '48%', zoom:'85%' },
            ],
          }
          setGameInfo1({
            correctOptions: [bakeryCrabBoxesWorried, bakeryBird, bakeryTrashCanCupcake],
            incorrectOptions: [bakeryLightSwitch, bakeryBreadRoll, bakeryBreadLoaf],
            position: [
              { x: '0%', y: '60%'},
              { x: '42%', y: '50%'},
              { x: '70%', y: '60%'},
              { x: '33%', y: '28%'},
              { x: '28%', y: '54%'},
              { x: '65%', y: '48%', zoom:'85%' },
            ],
          })
          setGameInfo2({
            options: [openDoor, wipeFace, throwAwayCupcake],
            position: [
              { x: '20%', y: '65%' },
              { x: '50%', y: '55%' },
              { x: '80%', y: '65%' },
            ],
            answer1ImagesEnd: [bakeryCrabBoxesWorried],
            answer2ImagesEnd: [bakeryNapkinWithBird],
            answer3ImagesEnd: [bakeryTrashCanMess],
            afterPosition: [
              { x: '0%', y: '60%' },
              { x: '42%', y: '50%' },
              { x: '70%', y: '60%' },
            ],
          })
          setGameInfo3({
            options: [smileAtCrab, throwAwayNapkin, cleanMess],
            position: [
              { x: '20%', y: '65%' },
              { x: '50%', y: '55%' },
              { x: '80%', y: '65%' },
            ],
            answer1ImagesEnd: [bakeryCrabSmiling],
            answer2ImagesEnd: [bigBirdHappy],
            answer3ImagesEnd: [bakerySparkle],
            afterPosition: [
              { x: '0%', y: '60%' },
              { x: '42%', y: '50%'},
              { x: '70%', y: '60%' },
            ],
          })
        }
        else{
          gameInfo1 = {
            correctOptions: [bakeryCrabBoxesWorried, bakeryBird, bakeryTrashCanCupcake],
            incorrectOptions: [bakeryLightSwitch, bakeryBreadRoll, bakeryBreadLoaf],
            position: [
              { x: '15%', y: '45%'},
              { x: '45%', y: '45%'},
              { x: '70%', y: '50%'},
              { x: '16%', y: '35%'},
              { x: '28%', y: '56%'},
              { x: '65%', y: '50%', zoom:'80%' },
            ],
          }
          setGameInfo1({
            correctOptions: [bakeryCrabBoxesWorried, bakeryBird, bakeryTrashCanCupcake],
            incorrectOptions: [bakeryLightSwitch, bakeryBreadRoll, bakeryBreadLoaf],
            position: [
              { x: '15%', y: '45%'},
              { x: '45%', y: '45%'},
              { x: '70%', y: '50%'},
              { x: '16%', y: '35%'},
              { x: '28%', y: '56%'},
              { x: '65%', y: '50%', zoom:'80%' },
            ],
          })
          setGameInfo2({
            options: [openDoor, wipeFace, throwAwayCupcake],
            position: [
              { x: '25%', y: '70%' },
              { x: '50%', y: '60%' },
              { x: '75%', y: '70%' },
            ],
            answer1ImagesEnd: [bakeryCrabBoxesWorried],
            answer2ImagesEnd: [bakeryNapkinWithBird],
            answer3ImagesEnd: [bakeryTrashCanMess],
            afterPosition: [
              { x: '15%', y: '45%' },
              { x: '45%', y: '45%' },
              { x: '70%', y: '50%' },
            ],
          })
          setGameInfo3({
            options: [smileAtCrab, throwAwayNapkin, cleanMess],
            position: [
              { x: '25%', y: '70%' },
              { x: '50%', y: '60%' },
              { x: '75%', y: '70%' },
            ],
            answer1ImagesEnd: [bakeryCrabSmiling],
            answer2ImagesEnd: [bigBirdHappy],
            answer3ImagesEnd: [bakerySparkle],
            afterPosition: [
              { x: '15%', y: '45%' },
              { x: '45%', y: '45%'},
              { x: '70%', y: '50%' },
            ],
          })
        }
        break;
      case 9:
        if (isIPhone()) {
          gameInfo1 = {
            correctOptions: [movieBird, movieMonkeyHungry, movieRecycleBinWithBottle],
            incorrectOptions: [moviePoster, movieLightSwitch, movieCrab],
            position: [
              { x: '40%', y: '65%'},
              { x: '10%', y: '50%'},
              { x: '80%', y: '60%', zoom:'60%'},
              { x: '56%', y: '45%'},
              { x: '9%', y: '35%'},
              { x: '60%', y: '70%'},
            ],
          }
          setGameInfo1({
            correctOptions: [movieBird, movieMonkeyHungry, movieRecycleBinWithBottle],
            incorrectOptions: [moviePoster, movieLightSwitch, movieCrab],
            position: [
              { x: '40%', y: '65%'},
              { x: '10%', y: '50%'},
              { x: '80%', y: '60%', zoom:'60%'},
              { x: '56%', y: '45%'},
              { x: '9%', y: '35%'},
              { x: '60%', y: '70%'},
            ],
          })
          setGameInfo2({
            options: [askForHelp, sharePopcorn, recycle],
            position: [
              { x: '60%', y: '70%' },
              { x: '13%', y: '60%' },
              { x: '80%', y: '60%' },
            ],
            answer1ImagesEnd: [movieCrabPointing],
            answer2ImagesEnd: [movieMonkey],
            answer3ImagesEnd: [movie2WaterBottles],
            afterPosition: [
              { x: '57.5%', y: '67.5%' },
              { x: '10%', y: '50%' },
              { x: '80%', y: '60%' }
            ],
          })
          setGameInfo3({
            options: [thankYou, shareMorePopcorn, recycleTheOtherBottles],
            position: [
              { x: '60%', y: '70%' },
              { x: '13%', y: '60%' },
              { x: '80%', y: '60%' },
            ],
            answer1ImagesEnd: [movieCrabThoughtHeart],
            answer2ImagesEnd: [movieMonkeyHappy],
            answer3ImagesEnd: [movieRecycleBinSparkle],
            answer4ImagesEnd: [demoDaysBirdHappy],
            afterPosition: [
              { x: '60%', y: '70%' },
              { x: '10%', y: '50%' },
              { x: '80%', y: '60%' }
            ],
          })
        }
        else if (isIPad()) {
          gameInfo1 = {
            correctOptions: [movieBird, movieMonkeyHungry, movieRecycleBinWithBottle],
            incorrectOptions: [moviePoster, movieLightSwitch, movieCrab],
            position: [
              { x: '40%', y: '65%'},
              { x: '10%', y: '50%'},
              { x: '80%', y: '50%', zoom:'60%'},
              { x: '65%', y: '53%', zoom:'130%'},
              { x: '0%', y: '27%'},
              { x: '60%', y: '70%'},
            ],
          }
          setGameInfo1({
            correctOptions: [movieBird, movieMonkeyHungry, movieRecycleBinWithBottle],
            incorrectOptions: [moviePoster, movieLightSwitch, movieCrab],
            position: [
              { x: '40%', y: '65%'},
              { x: '10%', y: '50%'},
              { x: '80%', y: '50%', zoom:'60%'},
              { x: '65%', y: '53%', zoom:'130%'},
              { x: '0%', y: '27%'},
              { x: '60%', y: '70%'},
            ],
          })
          setGameInfo2({
            options: [askForHelp, sharePopcorn, recycle],
            position: [
              { x: '60%', y: '70%' },
              { x: '13%', y: '60%' },
              { x: '80%', y: '50%' },
            ],
            answer1ImagesEnd: [movieCrabPointing],
            answer2ImagesEnd: [movieMonkey],
            answer3ImagesEnd: [movie2WaterBottles],
            afterPosition: [
              { x: '57.5%', y: '67.5%' },
              { x: '10%', y: '50%' },
              { x: '80%', y: '50%' }
            ],
          })
          setGameInfo3({
            options: [thankYou, shareMorePopcorn, recycleTheOtherBottles],
            position: [
              { x: '60%', y: '70%' },
              { x: '13%', y: '60%' },
              { x: '80%', y: '50%' },
            ],
            answer1ImagesEnd: [movieCrabThoughtHeart],
            answer2ImagesEnd: [movieMonkeyHappy],
            answer3ImagesEnd: [movieRecycleBinSparkle],
            answer4ImagesEnd: [demoDaysBirdHappy],
            afterPosition: [
              { x: '60%', y: '70%' },
              { x: '10%', y: '50%' },
              { x: '80%', y: '50%' }
            ],
          })
        }
        else{ 
          gameInfo1 = {
            correctOptions: [movieBird, movieMonkeyHungry, movieRecycleBinWithBottle],
            incorrectOptions: [moviePoster, movieLightSwitch, movieCrab],
            position: [
              { x: '40%', y: '65%'},
              { x: '10%', y: '50%'},
              { x: '80%', y: '60%', zoom:'60%'},
              { x: '56%', y: '45%'},
              { x: '9%', y: '35%'},
              { x: '60%', y: '70%'},
            ],
          }
          setGameInfo1({
            correctOptions: [movieBird, movieMonkeyHungry, movieRecycleBinWithBottle],
            incorrectOptions: [moviePoster, movieLightSwitch, movieCrab],
            position: [
              { x: '40%', y: '65%'},
              { x: '10%', y: '50%'},
              { x: '80%', y: '60%', zoom:'60%'},
              { x: '56%', y: '45%'},
              { x: '9%', y: '35%'},
              { x: '60%', y: '70%'},
            ],
          })
          setGameInfo2({
            options: [askForHelp, sharePopcorn, recycle],
            position: [
              { x: '60%', y: '70%' },
              { x: '13%', y: '60%' },
              { x: '80%', y: '60%' },
            ],
            answer1ImagesEnd: [movieCrabPointing],
            answer2ImagesEnd: [movieMonkey],
            answer3ImagesEnd: [movie2WaterBottles],
            afterPosition: [
              { x: '57.5%', y: '67.5%' },
              { x: '10%', y: '50%' },
              { x: '80%', y: '60%' }
            ],
          })
          setGameInfo3({
            options: [thankYou, shareMorePopcorn, recycleTheOtherBottles],
            position: [
              { x: '60%', y: '70%' },
              { x: '13%', y: '60%' },
              { x: '80%', y: '60%' },
            ],
            answer1ImagesEnd: [movieCrabThoughtHeart],
            answer2ImagesEnd: [movieMonkeyHappy],
            answer3ImagesEnd: [movieRecycleBinSparkle],
            answer4ImagesEnd: [demoDaysBirdHappy],
            afterPosition: [
              { x: '60%', y: '70%' },
              { x: '10%', y: '50%' },
              { x: '80%', y: '60%' }
            ],
          })
        }
        break;
      default:
        break;
    }
    setupGame1(gameInfo1)
  }, []);

  const updateScore = async (score1) => {
    try {
      await API.post('TIR', '/v3/student/result', {
        body: {
          student_id: login.studentid,
          metric: "practice_caring",
          result: JSON.stringify({
            day: props.module.currentday,
            created: new Date().toISOString(),
            values: [{ value: score1, target: 3 }],
          }),
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleCorrectImage = async () => {
    if (selectedCorrectImage === 3){
      if (firstTime) setScore(score+1);
      setIntroSound('');
      setQuestion(false);
      setTtitle('Step 2: Fix it')
      setChangeText('Drag the item to fix the problem')
      setSeletedImgX1(gameInfo2.position[0].x)
      setSeletedImgY1(gameInfo2.position[0].y)
      setTargetKey1(gameInfo2.options[0].title)
      setSeletedImgX2(gameInfo2.position[1].x)
      setSeletedImgY2(gameInfo2.position[1].y)
      setTargetKey2(gameInfo2.options[1].title)
      setSeletedImgX3(gameInfo2.position[2].x)
      setSeletedImgY3(gameInfo2.position[2].y)
      setTargetKey3(gameInfo2.options[2].title)
      if (props.day4){
        setWrongImg1(null)
        setWrongImg2(null)
        setWrongImg3(null)
      }
      setSeletedImg1(generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg'))
      setSeletedImg2(generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg'))
      setSeletedImg3(generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg'))
      let numArray = [];
      numArray = [
        gameInfo2.options[0],
        gameInfo2.options[1],
        gameInfo2.options[2],
      ];
      numArray = numArray
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
      setMatchOptions(numArray);
      setAnimationEffect('');
      setIntroSound(getVideo('appfiles/caring/practice_game_days_step_2_fix_it.mp3', login));
      setQuestion(true);
      setPractice2(true)

    }
    else if (selectedCorrectImage === 6){
      if (item1 && item2 && item3) setScore(score+1);
      setFirstTime1(true);
      setFirstTime2(true);
      setFirstTime3(true);
      setItem1(true);
      setItem2(true);
      setItem3(true);
      setIntroSound('');
      setQuestion(false);
      setPractice2(false)
      setTtitle('Step 3: Make it even better')
      setChangeText('Drag the item to make it even better!')
      setSeletedImgX1(gameInfo3.position[0].x)
      setSeletedImgY1(gameInfo3.position[0].y)
      setTargetKey1(gameInfo3.options[0].title)
      setSeletedImgX2(gameInfo3.position[1].x)
      setSeletedImgY2(gameInfo3.position[1].y)
      setTargetKey2(gameInfo3.options[1].title)
      setSeletedImgX3(gameInfo3.position[2].x)
      setSeletedImgY3(gameInfo3.position[2].y)
      setTargetKey3(gameInfo3.options[2].title)
      setSeletedImg1(generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg'))
      setSeletedImg2(generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg'))
      setSeletedImg3(generateImageUrl('images/Module20Images/practice/U4_M5_DropZone.svg'))
      let numArray = [];
      numArray = [
        gameInfo3.options[0],
        gameInfo3.options[1],
        gameInfo3.options[2],
      ];
      numArray = numArray
        .map((value) => ({ value, sort: Math.random() }))
        .sort((a, b) => a.sort - b.sort)
        .map(({ value }) => value);
      setMatchOptions(numArray);
      setAnimationEffect('');
      setIntroSound(getVideo('appfiles/caring/practice_game_days_step_3_make_it_better.mp3', login));
      setQuestion(true);
      setPractice3(true)
    }
    else if (selectedCorrectImage === 9) {
        await sleep(1000);
        props.onFinish();
    }
  }

  useEffect(() => {
    handleCorrectImage();
  }, [selectedCorrectImage]);

  // Sets up the game by selecting which possible answers to display in what order based on the current feeling.
  async function setupGame1(Info1) {
    setTtitle('Step 1: See it')
    setChangeText('Touch the 3 problems that need to be fixed')
    setCorrectImgX1(Info1.position[0].x);
    setCorrectImgY1(Info1.position[0].y);
    setCorrectImgX2(Info1.position[1].x);
    setCorrectImgY2(Info1.position[1].y);
    setCorrectImgX3(Info1.position[2].x);
    setCorrectImgY3(Info1.position[2].y);
    setWrongImgX1(Info1.position[3].x);
    setWrongImgY1(Info1.position[3].y);
    setWrongImgX2(Info1.position[4].x);
    setWrongImgY2(Info1.position[4].y);
    setWrongImgX3(Info1.position[5].x);
    setWrongImgY3(Info1.position[5].y);
    setCorrectImg1(Info1.correctOptions[0])
    setCorrectImg2(Info1.correctOptions[1])
    setCorrectImg3(Info1.correctOptions[2])
    setWrongImg1(Info1.incorrectOptions[0])
    setWrongImg2(Info1.incorrectOptions[1])
    setWrongImg3(Info1.incorrectOptions[2])
    setCorrectImg1Zoom(Info1.position[0].zoom)
    setCorrectImg2Zoom(Info1.position[1].zoom)
    setCorrectImg3Zoom(Info1.position[2].zoom)
    setWrongImg1Zoom(Info1.position[3].zoom)
    setWrongImg2Zoom(Info1.position[4].zoom)
    setWrongImg3Zoom(Info1.position[5].zoom)
    setIntroSound(getVideo('appfiles/caring/practice_game_days_step_1_see_it.mp3', login));
    setQuestion(true);
    setPractice1(true)
  }

  // Finds out what the user selected, and uses that as the current answer.
  async function onDrag(option) {
    if(targetKey1 === option.title){
      setItem1(false);
    }
    else if (targetKey2 === option.title){
      setItem2(false);
    }
    else if (targetKey3 === option.title){
      setItem3(false);
    }
    setWrongDrag(true)
    setQuestion(false);
    await sleep(500);
    setIntroSound(await getVideo(option.audioPrompt, login));
    setQuestion(true);
  }

  async function onDrop(order) {
    if(order === targetKey1){
      setFirstTime1(false)
    }
    else if (order === targetKey2){
      setFirstTime2(false)
    }
    else if (order === targetKey3){
      setFirstTime3(false)
    }
    if (wrongDragRef.current){
      const tryAgainAudio = new Audio(tryAgainSound)
      tryAgainAudio.play()
    }
  }





  const onHit1 = async (e) => {
    if (firstTime1) setItem1(true);
    const audio = new Audio(
      transitionSound
    );
    setWrongDrag(false)
    audio.play();
    setSeletedImg1(null);
    e.containerElem.style.visibility = 'hidden';
    if(practice2){
      setCorrectImg1(gameInfo2.answer1ImagesEnd)
      setCorrectImgX1(gameInfo2.afterPosition[0].x);
      setCorrectImgY1(gameInfo2.afterPosition[0].y);
      if(props.day7){
        setWrongImg1(null)
        setDay7Background(generateImageUrl('images/newDesign/Unit4Module20/Bakery/background/U4M5BakeryBGOpen.png'))
      }
      else if(props.day8){
        setWrongImg2(gameInfo1.correctOptions[0])
        setWrongImgX2('40%')
        setWrongImgY2('65%')
        setWrongImg3(null)
      }
    }
    else if(practice3){
      setCorrectImg1(gameInfo3.answer1ImagesEnd);
      setCorrectImgX1(gameInfo3.afterPosition[0].x);
      setCorrectImgY1(gameInfo3.afterPosition[0].y);
      if(props.day4){
        setWrongImg1(gameInfo3.answer4ImagesEnd)
        setWrongImgX1('75%')
        setWrongImgY1('47%')
      }
      else if(props.day5){
        setWrongImg1(gameInfo3.answer4ImagesEnd)
        if(window.innerWidth < 800){
          setWrongImgX1('5%')
          setWrongImgY1('0')
        }
        else{
          setWrongImgX1('10%')
          setWrongImgY1('')
        }
      }
      else if(props.day8){
        setWrongImg2(gameInfo3.answer4ImagesEnd)
      }
    }
    setSelectedCorrectImage(selectedCorrectImage+1)
  };

  const onHit2 = async (e) => {
    if (firstTime2) setItem2(true);
    const audio = new Audio(
      transitionSound
    );
    setWrongDrag(false)
    audio.play();
    setSeletedImg2(null);
    e.containerElem.style.visibility = 'hidden';
    if(practice2){
      setCorrectImg2(gameInfo2.answer2ImagesEnd)
      setCorrectImgX2(gameInfo2.afterPosition[1].x);
      setCorrectImgY2(gameInfo2.afterPosition[1].y);
    }
    else if(practice3){
      if(props.day5){
        document.getElementById('hairMonkey').style.display='none'
      }
      setCorrectImg2(gameInfo3.answer2ImagesEnd)
      setCorrectImgX2(gameInfo3.afterPosition[1].x);
      setCorrectImgY2(gameInfo3.afterPosition[1].y);
      setCorrectImg2Zoom(gameInfo3.afterPosition[1].zoom)
    }
    setSelectedCorrectImage(selectedCorrectImage+1)
  };

  const onHit3 = async (e) => {
    if (firstTime3) setItem3(true);
    const audio = new Audio(
      transitionSound
    );
    setWrongDrag(false)
    audio.play();
    setSeletedImg3(null);
    e.containerElem.style.visibility = 'hidden';
    if(practice2){
      setCorrectImg3(gameInfo2.answer3ImagesEnd)
      setCorrectImgX3(gameInfo2.afterPosition[2].x);
      setCorrectImgY3(gameInfo2.afterPosition[2].y);
    }
    else if(practice3){
      setCorrectImg3(gameInfo3.answer3ImagesEnd)
      setCorrectImgX3(gameInfo3.afterPosition[2].x);
      setCorrectImgY3(gameInfo3.afterPosition[2].y);
    }
    setSelectedCorrectImage(selectedCorrectImage+1)
  };

  // The HTML code for the practice
  return (
    <>
      {practice1 && (
        <div
          className='practiceSituation'
          style={{ backgroundImage: `url(${background})` }}
        >
          {props.day7 && <img
            className='module20BG'
            src={day7Background}
          ></img>}
          <img
            className='back-btn-ftb'
            src={Exit}
            onClick={() => {
              props.onClose();
            }}
          ></img>
          <br/>
          <h2 className='practiceSituationHeader'>{title}</h2>
          <h3 className='practiceSituationQuestion'>{changeText}</h3>
          {(props.day5) && <img alt='' id='hairMonkey' src={generateImageUrl('images/Module20Images/practice/Hairstylist_Monkey.svg')}  />}
          <div
            className='gameElement'
            id={animationEffectAfter}
            style={{ top: correctImgY1, left: correctImgX1, zIndex:2, zoom: correctImg1Zoom }}
            onClick={() => {
              const audio = new Audio(
                generateImageUrl('media/Module1Videos/button_accept_item.mp3')
              );
              audio.play();
              document.getElementsByClassName(
                'gameElement'
              )[0].style.animation  = 'highlights 1s infinite alternate';
              document.getElementsByClassName(
                'gameElement'
              )[0].style.pointerEvents = 'none';
              setSelectedCorrectImage(selectedCorrectImage+1)
            }}
          >
            <div className='imgElement'>
              <img alt='' src={correctImg1} />
            </div>
          </div>
          <div
            className='gameElement'
            id={animationEffectAfter}
            style={{ top: correctImgY2, left: correctImgX2, zIndex:2, zoom: correctImg2Zoom }}
            onClick={() => {
              const audio = new Audio(
                generateImageUrl('media/Module1Videos/button_accept_item.mp3')
              );
              audio.play();
              document.getElementsByClassName(
                'gameElement'
              )[1].style.animation  = 'highlights 1s infinite alternate';
              document.getElementsByClassName(
                'gameElement'
              )[1].style.pointerEvents = 'none';
              setSelectedCorrectImage(selectedCorrectImage+1)
            }}
          >
            <div className='imgElement'>
              <img alt='' src={correctImg2} />
            </div>
          </div>
          {(props.day5) && 
            <div className='salonShelf'>
              <div className='waterSink'>
                <img
                  className='sink'
                  src={generateImageUrl("images/newDesign/Unit4Module20/Salon/assets/Unit4Module20SalonSink.png")}
                  alt='sink'
                />
                <div
                  className='gameElement'
                  id={animationEffectAfter}
                  style={{ top: correctImgY3, left: correctImgX3, zIndex:2, zoom: correctImg3Zoom }}
                  onClick={() => {
                    const audio = new Audio(
                      generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                    );
                    audio.play();
                    document.getElementsByClassName(
                      'gameElement'
                    )[2].style.animation  = 'highlights 1s infinite alternate';
                    document.getElementsByClassName(
                      'gameElement'
                    )[2].style.pointerEvents = 'none';
                    setSelectedCorrectImage(selectedCorrectImage+1)
                  }}
                >
                  <div className='imgElement'>
                    <img alt='' src={correctImg3} />
                  </div>
                </div>
                {seletedImg3 &&(
                  <div
                    className='seletedImage'
                    style={{ top: seletedImgY3, left: seletedImgX3 }}
                  >
                    <DropTarget
                      targetKey={targetKey3}
                      onHit={(e) => {
                        onHit3(e);
                      }}
                      style={{ height: '150px', width: '150px' }}
                    >
                      <img alt='' className='selectedBox' src={seletedImg3} />
                    </DropTarget>
                  </div>
                )}
              </div>
              <img
                className='shelf'
                src={generateImageUrl("images/newDesign/Unit4Module20/Salon/assets/shelf.png")}
                alt='shelf'
              />
              <div
                className='gameElement'
                id={animationEffect}
                style={{ bottom: wrongImgY1, left: wrongImgX1, zoom: wrongImg1Zoom }}
                onClick={() => {
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[3].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[3].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg1} />
                </div>
              </div>
              <div
                className='gameElement'
                id={animationEffect}
                style={{ bottom: wrongImgY2, left: wrongImgX2, zoom: wrongImg2Zoom }}
                onClick={() => {
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[4].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[4].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg2} />
                </div>
              </div>
              <div
                className='gameElement'
                id={animationEffect}
                style={{ bottom: wrongImgY3, left: wrongImgX3, zoom: wrongImg3Zoom }}
                onClick={() => {
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[5].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[5].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg3} />
                </div>
              </div>
            </div>
          }
          {(props.day6) && 
            <div className='clothingShelf'>
              <img
                className='shelf'
                src={generateImageUrl("images/newDesign/Unit4Module20/Clothing/assets/Unit4Module20ClothingShelf.png")}
                alt='shelf'
              />
              <div
                className='gameElement'
                id={animationEffectAfter}
                style={{ top: correctImgY3, left: correctImgX3, zIndex:2, zoom: correctImg3Zoom }}
                onClick={() => {
                  const audio = new Audio(
                    generateImageUrl('media/Module1Videos/button_accept_item.mp3')
                  );
                  audio.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[2].style.animation  = 'highlights 1s infinite alternate';
                  document.getElementsByClassName(
                    'gameElement'
                  )[2].style.pointerEvents = 'none';
                  setSelectedCorrectImage(selectedCorrectImage+1)
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={correctImg3} />
                </div>
              </div>
              <div
                className='gameElement'
                id={animationEffect}
                style={{ top: wrongImgY1, left: wrongImgX1, zoom: wrongImg1Zoom }}
                onClick={() => {
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[3].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[3].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg1} />
                </div>
              </div>
              <div
                className='gameElement'
                id={animationEffect}
                style={{ top: wrongImgY2, left: wrongImgX2, zoom: wrongImg2Zoom }}
                onClick={() => {
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[4].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[4].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg2} />
                </div>
              </div>
              {seletedImg3 &&(
                <div
                  className='seletedImage'
                  style={{ top: seletedImgY3, left: seletedImgX3 }}
                >
                  <DropTarget
                    targetKey={targetKey3}
                    onHit={(e) => {
                      onHit3(e);
                    }}
                    style={{ height: '150px', width: '150px' }}
                  >
                    <img alt='' className='selectedBox' src={seletedImg3} />
                  </DropTarget>
                </div>
              )}
            </div>
          }
          {!props.day6 && !props.day5 && <div
            className='gameElement'
            id={animationEffectAfter}
            style={{ top: correctImgY3, left: correctImgX3, zIndex:2, zoom: correctImg3Zoom }}
            onClick={() => {
              const audio = new Audio(
                generateImageUrl('media/Module1Videos/button_accept_item.mp3')
              );
              audio.play();
              document.getElementsByClassName(
                'gameElement'
              )[2].style.animation  = 'highlights 1s infinite alternate';
              document.getElementsByClassName(
                'gameElement'
              )[2].style.pointerEvents = 'none';
              setSelectedCorrectImage(selectedCorrectImage+1)
            }}
          >
            <div className='imgElement'>
              <img alt='' src={correctImg3} />
            </div>
          </div>}
          {(!props.day6) && !props.day5 && <div
            className='gameElement'
            id={animationEffect}
            style={props.day8 ? { bottom: wrongImgY1, left: wrongImgX1, zoom: wrongImg1Zoom } : { top: wrongImgY1, left: wrongImgX1, zoom: wrongImg1Zoom }}
            onClick={() => {
              let tryAgain = new Audio(tryAgainSound)
              tryAgain.play();
              document.getElementsByClassName(
                'gameElement'
              )[3].style.pointerEvents = 'none';
              document.getElementsByClassName(
                'gameElement'
              )[3].style.animationDuration = '0s';
              setFirstTime(false);
            }}
          >
            <div className='imgElement'>
              <img alt='' src={wrongImg1} />
            </div>
          </div>}
          {(props.day7) && 
            <div className='breadShelf'>
              <img
                className='shelf'
                src={generateImageUrl("images/newDesign/Unit4Module20/Bakery/assets/Unit4Module20BakeryShelf.png")}
                alt='shelf'
              />
              <div
                className='gameElement'
                id={animationEffect}
                style={{ top: wrongImgY2, left: wrongImgX2, zoom: wrongImg2Zoom }}
                onClick={() => {
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[4].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[4].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg2} />
                </div>
              </div>
              <div
                className='gameElement'
                id={animationEffect}
                style={{ top: wrongImgY3, left: wrongImgX3, zoom: wrongImg3Zoom }}
                onClick={() => {
                  let tryAgain = new Audio(tryAgainSound)
                  tryAgain.play();
                  document.getElementsByClassName(
                    'gameElement'
                  )[5].style.pointerEvents = 'none';
                  document.getElementsByClassName(
                    'gameElement'
                  )[5].style.animationDuration = '0s';
                  setFirstTime(false);
                }}
              >
                <div className='imgElement'>
                  <img alt='' src={wrongImg3} />
                </div>
              </div>
            </div>
          }
          {!props.day6 && !props.day7 && !props.day5 && <div
            className='gameElement'
            id={animationEffect}
            style={{ top: wrongImgY2, left: wrongImgX2, zoom: wrongImg2Zoom }}
            onClick={() => {
              let tryAgain = new Audio(tryAgainSound)
              tryAgain.play();
              document.getElementsByClassName(
                'gameElement'
              )[4].style.pointerEvents = 'none';
              document.getElementsByClassName(
                'gameElement'
              )[4].style.animationDuration = '0s';
              setFirstTime(false);
            }}
          >
            <div className='imgElement'>
              <img alt='' src={wrongImg2} />
            </div>
          </div>}
          {!props.day7 && !props.day5 && <div
            className='gameElement'
            id={animationEffect}
            style={ { top: wrongImgY3, left: wrongImgX3, zoom: wrongImg3Zoom }}
            onClick={() => {
              let tryAgain = new Audio(tryAgainSound)
              tryAgain.play();
              document.getElementsByClassName(
                'gameElement'
              )[5].style.pointerEvents = 'none';
              document.getElementsByClassName(
                'gameElement'
              )[5].style.animationDuration = '0s';
              setFirstTime(false);
            }}
          >
            <div className='imgElement'>
              <img alt='' src={wrongImg3} />
            </div>
          </div>}
          {seletedImg1 && (
            <div
              className='seletedImage'
              style={{ top: seletedImgY1, left: seletedImgX1 }}
            >
              <DropTarget
                targetKey={targetKey1}
                onHit={(e) => {
                  onHit1(e);
                }}
                
                style={{ height: '150px', width: '150px' }}
              >
                <img alt='' className='selectedBox' src={seletedImg1} />
              </DropTarget>
            </div>
            
          )}
          {seletedImg2 && (
            <div
              className='seletedImage'
              style={{ top: seletedImgY2, left: seletedImgX2 }}
            >
              <DropTarget
                targetKey={targetKey2}
                onHit={(e) => {
                  onHit2(e);
                }}
                style={{ height: '150px', width: '150px' }}
              >
                <img alt='' className='selectedBox' src={seletedImg2} />
              </DropTarget>
            </div>
            
          )}
          {seletedImg3 && !props.day6  && !props.day5 &&(
            <div
              className='seletedImage'
              style={{ top: seletedImgY3, left: seletedImgX3 }}
            >
              <DropTarget
                targetKey={targetKey3}
                onHit={(e) => {
                  onHit3(e);
                }}
                style={{ height: '150px', width: '150px' }}
              >
                <img alt='' className='selectedBox' src={seletedImg3} />
              </DropTarget>
            </div>
          )}
          {practice2 && (
            <div className='practice20GridDay4'>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[0], id: 0 }}
                  targetKey={matchOptions[0].title}
                  onDragStart={() => onDrag(matchOptions[0])}
                  onDragEnd={() => onDrop(matchOptions[0].title)}
                >
                  {matchOptions[0] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[0].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[1], id: 1 }}
                  targetKey={matchOptions[1].title}
                  onDragStart={() => onDrag(matchOptions[1])}
                  onDragEnd={() => onDrop(matchOptions[1].title)}
                >
                  {matchOptions[1] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[1].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[2], id: 2 }}
                  targetKey={matchOptions[2].title}
                  onDragStart={() => onDrag(matchOptions[2])}
                  onDragEnd={() => onDrop(matchOptions[2].title)}
                >
                  {matchOptions[2] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[2].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
            </div>
          )}
          {practice3 && (
            <div className='practice20GridDay4'>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[0], id: 0 }}
                  targetKey={matchOptions[0].title}
                  onDragStart={() => onDrag(matchOptions[0])}
                  onDragEnd={() => onDrop(matchOptions[0].title)}
                >
                  {matchOptions[0] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[0].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[1], id: 1 }}
                  targetKey={matchOptions[1].title}
                  onDragStart={() => onDrag(matchOptions[1])}
                  onDragEnd={() => onDrop(matchOptions[1].title)}
                >
                  {matchOptions[1] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[1].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
              <div className='grid-item20'>
                <DragDropContainer
                  dragData={{ option: matchOptions[2], id: 2 }}
                  targetKey={matchOptions[2].title}
                  onDragStart={() => onDrag(matchOptions[2])}
                  onDragEnd={() => onDrop(matchOptions[2].title)}
                >
                  {matchOptions[2] && (
                    <div className='optionImage20'>
                      <div className='set20'>
                        <img
                          className='crabExpression20'
                          src={matchOptions[2].img}
                        />
                      </div>
                    </div>
                  )}
                </DragDropContainer>
              </div>
            </div>
          )}          
        </div>
      )}
      {question && (
        <audio
          autoPlay
          onEnded={() => {
            setQuestion(false);
          }}
        >
          <source src={introSound}></source>
        </audio>
      )}
    </>
  );
};
export default PracticeSituation;
